var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSortAsc = function SvgSortAsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.401 8.88 6H3.12L6 2.401ZM6 0 0 7.5h12L6 0Zm2.88 12L6 15.598 3.12 12h5.76ZM12 10.5H0L6 18l6-7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6 .5 5.196 6.75H.804L6 .5Z"
  })));
};
export default SvgSortAsc;